export default __webpack_public_path__ + "static/media/productOnlineStoreAF.54fa18ef.png";